
import { mapState } from 'vuex'
import dealerDownload from '~/components/dealer/popup/dealerDownload.vue'

export default {
  name: 'RelationTree',
  components: {
    dealerDownload
  },
  props: {
    ispage: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {},
      required: true
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 300
    },
    familytree: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      myChart: null,
      treedata: this.familytree
    }
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo',
      contentcookie: 'contentcookie'
    }),
    contentcookie1() {
      return this.contentcookie
    }
  },
  watch: {
    contentcookie1() {
      this.loginfn()
    }
  },
  methods: {
    loginfn () {
      this.$api.common
        .CV3(
          {
            code: this.data?.code,
            type: 2,
            userId: this.$store.state.user.userId || ''
          },
          {
            Routes: 'wikifxagg$family_tree_entry_setting'
          }
        ).then((res) => {
          console.log(res?.wikifxagg?.family_tree_entry_setting?.data, 8889)
          this.treedata = res?.wikifxagg?.family_tree_entry_setting?.data || {}
        })
        .catch((err) => {
          console.log('wikifxagg$family_tree_entry_setting', err)
        })
    },
    showVipDialog() {

      if (!this.$store.state.user.userId) {
        this.$store.commit('loginClose', true)
        return
      }
      const info = this.data

      // const name = this.getOnlyShortName(info.shortName, info.localShortName)
      this.info = {
        ico: info.ico,
        name: info.name
      }
      // console.log(111111, this.info, this.data)
      this.$refs.dealerDownload.open(this.info, info.name)
    },
    getOnlyShortName(sName, sName1) {
      if (!sName) {
        return sName1
      } else {
        return sName
      }
    },
    totreefn () {
      window.open(`/${this.$store.state.LanguageCode}/family/${this.data?.code}.html`)
    }
  }
}
